<h2 class="banner-title">{{data.title | translate}}</h2>
<p class="banner-description">{{data.description | translate}}</p>
